export const Loader = () => {
    const text = "Loading...";
  
    return (
      <div className="flex items-center justify-center m-4">
        <div className="flex space-x-1 text-2xl font-medium text-purple-900 mb-2">
          {text.split("").map((letter, i) => (
            <span
              key={i}
              className="animate-bounce"
              style={{
                animationDelay: `${i * 0.1}s`,
              }}
            >
              {letter}
            </span>
          ))}
          <span className="animate-ping text-white">.</span>
          <span className="animate-ping text-white delay-200">.</span>
          <span className="animate-ping text-white delay-400">.</span>
        </div>
      </div>
    );
  };
